import React, { useState, useRef, useEffect } from "react";
import Bredcrum from "../../components/bredcrum";
import { Tag } from "primereact/tag";
import { Tablescom } from "../../components/tablescomp";
import { Toast } from "primereact/toast";

import { userservices } from "../../services/userServices";
import { productservices } from "../../services/productServices";
import { supplierservices } from "../../services/supplierServices";
import { manufacturingServices } from "../../services/manufacturingServices";


import { Titlebar, Searchbox, Label } from "../../components/fieldsComp";
import  { useLocation } from "react-router";

function Editmanufacturing() {
  const location = useLocation(null);  
  const toast = useRef(null);
  const [errors, setErrors] = useState({});
  const [productnamesku, setProductnamesku] = useState('');
  const [productlist,setProductlist] = useState([]);

  const [formData, setFormData] = useState({
    order_id: "",
    product_id: "",
    product_name: "",
    quantity_to_produce: "",
    date: "",
    start_date: "",
    end_date: "",
    status: "",
    priority: "",
    remarks: "",
    manufacture_id: "",
  });


  useEffect(()=>{
    console.log("location data");
    console.log(location.state?.manufacturing);
    setFormData(location.state?.manufacturing);
    getproduct();
  },[]);

const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === 'product_id') {
    productservices.getbulkproduct(value)
      .then((response) => {
        if (response.status === 200) {
          const productInfo = response.data.data[0];
          const productNameSku = `${productInfo.product_name} / ${productInfo.sku_code}`;
          
          setProductnamesku(productNameSku);
          setFormData(prev => ({
            ...prev,
            product_id: value,
            product_name: productNameSku
          }));
        }
      })
      .catch((error) => {
        console.error("Failed to fetch product info:", error);
      });
  } else {
    // For other fields, update normally
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }
};


  const validate = () => {
    const newErrors = {};
    if (!formData.order_id) newErrors.order_id = "Order id is required";
    if (!formData.product_id) newErrors.product_id = "Product id is required";
    if (!formData.quantity_to_produce || isNaN(formData.quantity_to_produce)) newErrors.quantity_to_produce = "Quantity To Produce is required";
    // if (!formData.date || isNaN(formData.date)) newErrors.date = "Created Date is required";
    if (!formData.start_date) newErrors.start_date = "Start Date is required";
    if (!formData.end_date) newErrors.end_date = "End Date is required";
    if (!formData.status) newErrors.status = "Status is required";
    if (!formData.priority) newErrors.priority = "Priority is required";
    if (!formData.manufacture_id) newErrors.manufacture_id = "Manufacture Id is required";

    // Add other field validations as needed

    return newErrors;
  };

  const refs = {
    order_id: useRef(null),
    product_id: useRef(null),
    quantity_to_produce: useRef(null),
    // date: useRef(null),
    start_date: useRef(null),
    end_date: useRef(null),
    status: useRef(null),
    priority: useRef(null),
    remarks: useRef(null),
    manufacture_id: useRef(null),
  };


  const handlesubmit = (e) => {
     e.preventDefault();

    
        const validationErrors = validate();
          setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
      // Focus first input with error
          const firstErrorKey = Object.keys(validationErrors)[0];
          if (refs[firstErrorKey]) {
            refs[firstErrorKey].current.focus();
          }
      return;
    }
    let dataToSend = { ...formData };
      if (productnamesku) {
        dataToSend.product_name = productnamesku;
      }
        manufacturingServices.editmanufacturing(dataToSend).then((response)=>{
            if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'Manufacturing', detail: 'Manufacturing updated successfully' }); 
            }else{
                toast.current.show({ severity: 'error', summary: 'Manufacturing', detail: `${response.data.data}` }); 
            }   
        }).catch((error)=>{
            toast.current.show({ severity: 'error', summary: 'Manufacturing', detail: 'Error' }); 
        });
    

    // Handle form submission here
  };

  const handleClose = () => {
    // Reset form or close modal logic
    console.log('Form Closed');
  };

  const getproduct = () =>{
    productservices.getbulkproduct().then((response)=>{
      console.warn(response);
        if(response.status ==200){
            setProductlist(response.data.data);  
        }else{
            setProductlist([]); 
        }
         
      }).catch((error)=>{
            setProductlist([]); 
      });
  }

  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"Product/addproduct"} divider={false} />
      <div class="row">
        {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}

        <Titlebar text={"Edit Manufacturing"} />
        <div className="col-md-12 mt-3">
          <div className="card ps-5 pe-5">
            <div className="card-body card-body-style">
              <div className="row">
                <div className="container mt-4"></div>
                <form onSubmit={(e) => handlesubmit(e)}>

                        <div class="row mb-3">
                            <div class="col-md-6">
                            <label for="order_id" class="form-label">Order ID</label>
                            <input type="text"  onChange={handleChange} ref={refs.order_id} class="form-control" 
                            id="order_id" name="order_id" placeholder="Enter Order ID" value={formData.order_id}/>
                             {errors.order_id && <span style={{ color: "red" }}>{errors.order_id}</span>}
                            </div>
                            <div class="col-md-6">
                            <label for="product_id" class="form-label">Product</label>
                            <select
                              className="form-control"
                              value={formData.product_id}
                              ref={refs.product_id}
                              name="product_id"
                              onChange={handleChange}
                            >
                              <option value="">Select Product</option>
                              {productlist.map((value, index) => (
                                <option key={index} value={value.id}>
                                  {value.product_name}
                                </option>
                              ))}
                            </select>

                            {errors.product_id && <span style={{ color: "red" }}>{errors.product_id}</span>}
                            </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-md-6">
                            <label for="product_name" class="form-label">Product /SKU NO</label>
                            <input type="text" readOnly class="form-control" id="product_name" 
                            name="product_name" placeholder="Enter Product Name" value={formData.product_name}/>
                            </div>

                          <div class="col-md-6">
                            <label for="quantity_to_produce" class="form-label">Quantity to Produce</label>
                            <input type="number" ref={refs.quantity_to_produce} class="form-control" 
                            id="quantity_to_produce" name="quantity_to_produce" value={formData.quantity_to_produce} placeholder="Enter Quantity"  onChange={handleChange} />
                             {errors.quantity_to_produce && <span style={{ color: "red" }}>{errors.quantity_to_produce}</span>}
                         </div>
                        </div>

                        

                        

                        <div class="row mb-3">
                            <div class="col-md-4">
                            <label for="date" class="form-label">Created Date</label>
                            <input type="date" ref={refs.date} class="form-control" id="date" 
                            name="date" value={formData.date} onChange={handleChange}/>
                            {errors.date && <span style={{ color: "red" }}>{errors.date}</span>}
                            </div>
                            <div class="col-md-4">
                            <label for="start_date" class="form-label">Start Date</label>
                            <input type="date" ref={refs.start_date} class="form-control" id="start_date" 
                            name="start_date"  onChange={handleChange} value={formData.start_date} />
                            {errors.start_date && <span style={{ color: "red" }}>{errors.start_date}</span>}
                            </div>
                            <div class="col-md-4">
                            <label for="end_date" class="form-label">End Date</label>
                            <input type="date" ref={refs.end_date} class="form-control" id="end_date" name="end_date"  
                            onChange={handleChange} value={formData.end_date} />
                            {errors.end_date && <span style={{ color: "red" }}>{errors.end_date}</span>}
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                            <label for="status" class="form-label">Status</label>
                            <select class="form-select" id="status" name="status" ref={refs.status} value={formData.status} onChange={handleChange}>
                               <option value="">Select Status</option> 
                                <option value="pending">Pending</option>
                                <option value="in_progress">In Progress</option>
                                <option value="completed">Completed</option>
                            </select>
                            {errors.status && <span style={{ color: "red" }}>{errors.status}</span>}
                            </div>
                            <div class="col-md-6">
                            <label for="priority" class="form-label">Priority</label>
                            <select class="form-select" id="priority" name="priority" ref={refs.priority}  value={formData.priority} onChange={handleChange}>
                                <option value="">Select Priority</option>
                                <option value="low">Low</option>
                                <option value="normal">Normal</option>
                                <option value="high">High</option>
                            </select>
                            {errors.priority && <span style={{ color: "red" }}>{errors.priority}</span>}
                            </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-md-4">
                              <label for="manufacture_id" class="form-label">Manufacture ID</label>
                              <select class="form-select" id="manufacture_id" value={formData.manufacture_id} name="manufacture_id" ref={refs.manufacture_id}  onChange={handleChange}>
                                  <option value="">Select Manufacture Name</option>
                                  <option value="1">m1</option>
                                  <option value="2">m2</option>
                                  <option value="3">m3</option>
                              </select>
                        {errors.manufacture_id && <span style={{ color: "red" }}>{errors.manufacture_id}</span>}
                          </div>
                          <div class="col-md-8">
                            <label for="remarks" class="form-label">Remarks</label>
                            <textarea class="form-control" id="remarks" name="remarks" rows="3" placeholder="Enter any remarks" 
                             onChange={handleChange} value={formData.remarks}>
                              {formData.remarks}
                            </textarea>
                          </div>
                        </div>


                    <div class="row">
                      <div class="col-md-6">
                        <button type="submit" class="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color">Update</button></div>
                      <div class="col-md-6">
                      <button type="button" class="btn color-white w-100 rounded custom-btn-color-secondary">Close</button>
                      </div>
                      </div>
                        {/* <button type="submit" class="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color">Submit</button> */}

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Editmanufacturing;
